export var marginTrade = 'Margin';
export var standardTrade = 'Standard';